import {FormatNumberWithDecimal} from '../../../../Utils/_helpers/string'
import {OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import React from 'react'

interface CountCardProps {
  label: string
  value: number
  icon?: string
  tooltipText?: string
  isLoading: boolean
}

const CountCard: React.FC<CountCardProps> = ({label, value, isLoading, tooltipText}) => {
  return (
    <div className='mt-3 p-9 shadow-sm rounded-4 bg-white text-left d-flex flex-column'>
      <div className='mb-6'></div>
      <h3 className='mb-4' style={{fontSize: '38px', fontWeight: '700'}}>
        {isLoading ? <Spinner /> : `${FormatNumberWithDecimal(value)}`}
      </h3>
      <span className='fs-4 text-black mb-3'>
        {label}
        {tooltipText && (
          <OverlayTrigger
            placement='bottom'
            delay={{show: 250, hide: 400}}
            overlay={<Tooltip id='tooltip-bottom'>{tooltipText}</Tooltip>}
          >
            <i className='bi bi-info-circle ms-2 text-muted'></i>
          </OverlayTrigger>
        )}
      </span>
    </div>
  )
}

export default CountCard
